import React from 'react';
import PropTypes from 'prop-types';
import InfoIcon from 'material-ui-icons/Info';
import {
  offerRequestInformationMutation,
  investorOffersQuery,
  offerQuery,
} from '../../../apollo';
import RequestInformationAction from './RequestInformationAction';
import { DASHBOARD_OFFER_LIMIT as limit } from '../../../config';

const OfferRequestInformation = ({ offerId, linkForm }) => (
  <RequestInformationAction
    offerId={offerId}
    mutation={offerRequestInformationMutation}
    refetchQueries={[
      {
        query: investorOffersQuery,
        variables: {
          query: {
            limit,
            skip: 0,
            sort: 'order',
            order: 'ASC',
            filter: {
              $or: [
                {
                  favorited: true,
                },
                {
                  requestedInformation: true,
                },
                {
                  readyToInvest: true,
                },
              ],
            },
          },
        },
      },
      {
        query: offerQuery,
        variables: {
          _id: offerId,
        },
      },
    ]}
    Icon={InfoIcon}
    title={linkForm ? 'Request Password' : 'Request Information'}
    dialogBody='Contact the bankers associated with this offer.'
    enableMessage
    linkForm={linkForm}
  />
);

OfferRequestInformation.propTypes = {
  offerId: PropTypes.string.isRequired,
  linkForm: PropTypes.bool,
};

export default OfferRequestInformation;



// WEBPACK FOOTER //
// ./src/components/OfferOverview/RequestInformationButton/index.js